// extracted by mini-css-extract-plugin
export default {"status":"ChangeOrderStatus_status__Vd5ow","card":"ChangeOrderStatus_card__ZhfJE"};